<template>
    <div class="top-bar">
        <ul class="top-bar__list">
            <li v-for="item in aclFilteredItems"
                class="top-bar__list-item"
                :class="item.id === activeItem ? 'top-bar__list-item--active' : ''">
                <router-link class="top-bar__link"
                   :class="item.id === activeItem ? 'top-bar__link--active' : ''"
                   :to="item.url">
                    {{ item.text }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'TopBar',
        props: ['activeItem'],
        data() {
            return {
                items: [
                    {
                        id: 'dashboard',
                        text: 'My Dashboard',
                        url: '/dashboard'
                    },
                    {
                        id: 'parametric-search',
                        text: 'My Parametric Search',
                        url: '/my-parametric-search'
                    },
                    {
                        id: 'documentation',
                        text: 'My Documentation',
                        url: '/my-documents'
                    },
                    {
                        id: 'subscription',
                        text: 'My Subscriptions',
                        url: '/my-subscription'
                    },
                    {
                        id: 'account',
                        text: 'My Account',
                        url: '/my-account'
                    },
                    {
                        id: 'support',
                        text: 'My Support',
                        url: '/my-support'
                    },
                    {
                        id: 'admin',
                        text: 'My Admin',
                        url: '/my-admin',
                        admin: true
                    },
                ]
            }
        },
        computed: {
            ...mapGetters(["isAdmin"]),
            aclFilteredItems() {
                return this.items.filter(i => {if(i.admin && !this.isAdmin) {return false;} else {return true;}});
            }
        },
    }
</script>

<style scoped lang="scss">
    .top-bar {
        background-color: #003b71;
        height: 60px;
        width: 100%;
        top: 50px;
        left: 0;
        z-index: 2;
        overflow-y: hidden;
        overflow-x: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .top-bar__list {
        list-style: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        min-width: fit-content;
        //margin-left: 16.6666666667%;

        @media (max-width: 991px) {
            margin-left: auto;
        }
    }

    .top-bar__link {
        color: #ffffff;
        padding: 1rem;
    }

    .top-bar__list-item {
        min-width: 180px;
        text-align: center;
    }

    .top-bar__list-item + .top-bar__list-item {
        border-left: #ffffff 1px solid;
    }

    .top-bar__link--active {
        border-bottom: #ffffff 5px solid;
    }
</style>
